import React, { useEffect } from "react";
import Swiper from "swiper/bundle";
import "swiper/css/bundle";
import { Link } from "react-router-dom";

const HomePage = () => {
  useEffect(() => {
    const swiper = new Swiper(".services-slider", {
      slidesPerView: 4,
      spaceBetween: 0,
      loop: true,
      speed: 1000,
      freeMode: true,
      autoplay: {
        delay: 2000,
      },
      navigation: {
        nextEl: ".services-swiper-button-next",
        prevEl: ".services-swiper-button-prev",
      },
      breakpoints: {
        10: {
          slidesPerView: 1,
        },
        575: {
          slidesPerView: 1,
        },

        768: {
          slidesPerView: 2,
        },

        992: {
          slidesPerView: 3,
        },
        1200: {
          slidesPerView: 4,
        },
      },
    });

    return () => swiper.destroy(true, true); // cleanup
  }, []);
  useEffect(() => {
    const swiper = new Swiper(".h3-partner_slider", {
      slidesPerView: 2,
      spaceBetween: 15,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
      breakpoints: {
        768: { slidesPerView: 3, spaceBetween: 30 },
        992: { slidesPerView: 6, spaceBetween: 30 },
      },
    });

    return () => swiper.destroy(true, true); // cleanup
  }, []);

  return (
    <main>
      {/* hero section starts here */}
      <section className="bg-[#F4F4FF] pt-[100px] overflow-hidden">
        <div className="container">
          <div className="grid grid-cols-12 items-center">
            <div className="lg:col-span-6 col-span-12">
              <div className="relative">
                <span className="xxl:text-xxl sm:text-lg text-sm uppercase font-bold text-secondary">
                  <i className="fa-solid fa-heart pr-[10px] text-[#FC4F4F]" />
                  Solutions for Better Health
                </span>
                <div className="relative">
                  <h1 className="text-[82px] max-md:text-[60px] font-bold mb-[20px] uppercase font-sora text-secondary leading-[1.2]">
                    Your <span className="text-primary">Health</span> Our Priority
                  </h1>
                  <img
                    src="assets/img/shaps-3.png"
                    alt="img"
                    className="absolute xl:-top-[40px] -top-[26px] xxl:right-0 xl:right-[0px] lg:right-[55px] md:right-[148px] sm:right-[50px] right-[8px] shaps-3 animate-bellring max-xl:w-50"
                  />
                </div>
                <p className="xxl:text-xxl xl:text-xl text-lg leading-32 xl:leading-34 pb-45 max-md:pb-[30px] text-gary font-normal">
                  We are dedicated to putting your health at the forefront of
                  everything we do. Our compassionate team of healthcare.
                </p>
                <div className="md:flex items-center gap-[18px] max-xl:flex-wrap">
                  <Link to="/plans" className="btn max-md:mb-[30px]">
                    <span>
                      Explore Plans
                      <i className="fa-solid fa-arrow-right" />
                    </span>
                  </Link>
                  <ul className="flex md:ml-14 max-md:pl-[20px] experience-team">
                    <li className="-ml-15">
                      <img
                        src="assets/img/team-1.png"
                        alt="img"
                        className="w-[60px]"
                      />
                    </li>
                    <li className="-ml-15">
                      <img
                        src="assets/img/team-2.png"
                        alt="img"
                        className="w-[60px]"
                      />
                    </li>
                    <li className="-ml-15">
                      <img
                        src="assets/img/team-3.png"
                        alt="img"
                        className="w-[60px]"
                      />
                    </li>
                    <li className="-ml-15">
                      <a href="" className="text-white">+</a>
                    </li>
                  </ul>
                  <div className="max-md:mt-2 max-md:ml-2">
                    <h6 className="font-bold text-secondary font-sora text-base">
                      50+
                    </h6>
                    <span className="text-secondary max-xxl:text-xs">
                      Experience Team
                    </span>
                  </div>
                </div>
              </div>
              <div className="flex xl:gap-[60px] sm:gap-[40px] gap-[10px] pt-[50px] max-md:pt-[30px]">
                <div className="w-[140px]">
                  <h2
                    data-max={500}
                    className="counter text-[52px] max-md:text-[40px] font-bold text-secondary font-sora"
                  >
                    <span>+</span>
                  </h2>
                  <span className="text-secondary max-md:text-xs max-md:leading-18 max-md:block">
                    Patients <span className="max-md:hidden">&nbsp;&nbsp;&nbsp;</span> Served
                  </span>
                </div>
                <div className="w-[140px]">
                  <h2
                    data-max={300}
                    className="counter text-[52px] max-md:text-[40px] font-bold text-secondary font-sora"
                  >
                    <span>+</span>
                  </h2>
                  <span className="text-secondary max-md:text-xs max-md:leading-18 max-md:block">
                    Reports Delivered
                  </span>
                </div>
                <div className="w-[140px]">
                  <h2
                    data-max={100}
                    className="counter text-[52px] max-md:text-[40px] font-bold text-secondary font-sora"
                  >
                    <span>+</span>
                  </h2>
                  <span className="text-secondary max-md:text-xs max-md:leading-18 max-md:block">
                    Expert Specialists
                  </span>
                </div>
              </div>
            </div>
            <div className="lg:col-span-6 col-span-12">
              <div className="relative">
                <img
                  src="assets/img/hero-img.png"
                  alt="img"
                  className="4xl:max-w-[125%] max-xl:mt-150 max-lg:mt-50"
                />
                <ul className="shaps">
                  <li className="absolute">
                    <img
                      src="assets/img/shaps-1.png"
                      alt="img"
                      className="max-w-[125%] animate-topshap max-md:w-70"
                    />
                  </li>
                  <li className="absolute">
                    <img
                      src="assets/img/shaps-2.png"
                      alt="img"
                      className="max-w-[125%] animate-topshap max-md:w-130 max-sm:w-70"
                    />
                  </li>
                  <li className="absolute">
                    <img
                      src="assets/img/shaps-4.png"
                      alt="img"
                      className="max-w-[125%] animate-fa-spin"
                    />
                  </li>
                  <li className="absolute">
                    <img
                      src="assets/img/shaps-5.png"
                      alt="img"
                      className="max-w-[125%] animate-fa-spin"
                    />
                  </li>
                  <li className="absolute">
                    <img
                      src="assets/img/shaps-6.png"
                      alt="img"
                      className="max-w-[125%] animate-fa-spin"
                    />
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* hero section ends here */}


      {/* services start here */}
      <section className="lg:py-[120px] md:py-[80px] py-[60px] max-md:pb-[50px]">
        <div className="container">
          <div className="xl:pb-[50px] lg:pb-[40px] pb-[30px] w-[fit-content]">
            <span className="capitalize font-semibold xxl:text-xxl xl:text-xl sm:text-lg text-base text-primary font-sora pb-[6px] block">
              # Medical Services
            </span>
            <h2 className="xl:text-5xl md:text-4xl sm:text-3xl text-2.5xl max-md:text-[36px] font-semibold text-secondary font-sora leading-[1.2]">
              One thing at a Time.
            </h2>
          </div>
          <div className="swiper services-slider">
            <div className="swiper-wrapper">
              <div className="swiper-slide group">
                <div className="relative mx-[10px] mb-[20px] portfolio-style">
                  <figure className="overflow-hidden">
                    <img
                      src="assets/img/portfolio-1.jpg"
                      alt="img"
                      className="group-hover:scale-[1.1] group-hover:rotate-[3deg] duration-500 w-full"
                    />
                  </figure>
                  <div className="absolute bottom-[30px] xxl:left-[30px] left-[20px] z-[2]">
                    <span className="text-white leading-24 bg-[#ffffff26] py-[10px] px-[15px] inline-block rounded-[10px] pb-2 group-hover:text-[#021935] group-hover:bg-white duration-500">
                      Diagnostics
                    </span>
                  </div>
                </div>
              </div>
              <div className="swiper-slide group">
                <div className="relative mx-[10px] mb-[20px] portfolio-style">
                  <figure className="overflow-hidden">
                    <img
                      src="assets/img/portfolio-2.jpg"
                      alt="img"
                      className="group-hover:scale-[1.1] group-hover:rotate-[3deg] duration-500 w-full"
                    />
                  </figure>
                  <div className="absolute bottom-[30px] xxl:left-[30px] left-[20px] z-[2]">
                    <span className="text-white leading-24 bg-[#ffffff26] py-[10px] px-[15px] inline-block rounded-[10px] pb-2 group-hover:text-[#021935] group-hover:bg-white duration-500">
                      Scans
                    </span>
                  </div>
                </div>
              </div>
              <div className="swiper-slide group">
                <div className="relative mx-[10px] mb-[20px]  portfolio-style">
                  <figure className="overflow-hidden">
                    <img
                      src="assets/img/portfolio-3.jpg"
                      alt="img"
                      className="group-hover:scale-[1.1] group-hover:rotate-[3deg] duration-500 w-full"
                    />
                  </figure>
                  <div className="absolute bottom-[30px] xxl:left-[30px] left-[20px] z-[2]">
                    <span className="text-white leading-24 bg-[#ffffff26] py-[10px] px-[15px] inline-block rounded-[10px] pb-2 group-hover:text-[#021935] group-hover:bg-white duration-500">
                      Pharmacy
                    </span>
                  </div>
                </div>
              </div>
              <div className="swiper-slide group">
                <div className="relative mx-[10px] mb-[20px]  portfolio-style">
                  <figure className="overflow-hidden">
                    <img
                      src="assets/img/portfolio-4.jpg"
                      alt="img"
                      className="group-hover:scale-[1.1] group-hover:rotate-[3deg] duration-500 w-full"
                    />
                  </figure>
                  <div className="absolute bottom-[30px] xxl:left-[30px] left-[20px] z-[2]">
                    <span className="text-white leading-24 bg-[#ffffff26] py-[10px] px-[15px] inline-block rounded-[10px] pb-2 group-hover:text-[#021935] group-hover:bg-white duration-500">
                      Tele Consultations
                    </span>
                  </div>
                </div>
              </div>
              <div className="swiper-slide group">
                <div className="relative mx-[10px] mb-[20px]  portfolio-style">
                  <figure className="overflow-hidden">
                    <img
                      src="assets/img/portfolio-5.jpg"
                      alt="img"
                      className="group-hover:scale-[1.1] group-hover:rotate-[3deg] duration-500 w-full"
                    />
                  </figure>
                  <div className="absolute bottom-[30px] xxl:left-[30px] left-[20px] z-[2]">
                    <span className="text-white leading-24 bg-[#ffffff26] py-[10px] px-[15px] inline-block rounded-[10px] pb-2 group-hover:text-[#021935] group-hover:bg-white duration-500">
                      Doctor Consultations
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* services ends here */}

      {/* about start here  */}
      <section className="xl:pb-[120px] lg:pb-[100px] sm:pb-[80px] pb-[60px] relative section-about-two">
        <div className="container">
          <div className="grid grid-cols-12 gap-[30px] items-center">
            <div className="lg:col-span-6 col-span-12 md:pr-[60px]">
              <div className="pb-[50px] w-[fit-content]">
                <span className="capitalize font-semibold xxl:text-xxl xl:text-xl sm:text-lg text-base text-primary font-sora pb-[6px] block">
                  # About Us
                </span>
                <h2 className="xxl:text-5xl xl:text-4.65xl md:text-3.8xl sm:text-3xl text-2.5xl max-md:text-[36px] font-semibold font-sora text-secondary leading-[1.2]">
                  Your Everyday Health Partner.
                </h2>
                <p className="mt-[25px] text-[18px] font-normal text-gary xl:leading-[30px] leading-[26px]">
                  We believe good health care should be simple, affordable, and focused on keeping you well. That's why we created OPD and Wellness Plans that give you reliable access to the regular check-ups, doctor visits, and screenings you need throughout the year.
                </p>
                <p className="mt-[25px] text-[18px] font-normal text-gary xl:leading-[30px] leading-[26px]">
                  We take the confusion out of health plans. Our mission is to be your trusted partner, making sure you have the easy, quality care required to stay healthy every day.
                </p>
              </div>
              <Link to="/contact" className="btn max-xxl:px-[30px]">
                <span>
                  Connect Now
                  <i className="fa-solid fa-arrow-right" />
                </span>
              </Link>
            </div>
            <div className="lg:col-span-6 col-span-12">
              <div className="relative">
                <img
                  src="assets/img/about-three.png"
                  alt="img"
                  className="relative z-10"
                />
                <img
                  src="assets/img/plus.png"
                  alt="img"
                  className="plus absolute max-xxl:w-[60%] max-lg:w-[38%]"
                />
                <img
                  src="assets/img/dots-img.png"
                  alt="img"
                  className="dots-img animate-fa-spin absolute"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* about end here  */}

      
      {/* client section starts here */}
      <section className="lg:pb-[120px] md:pb-[80px] pb-[60px] max-md:pb-[50px]">
        <div className="container">
          <div className="xl:pb-[30px] lg:pb-[40px] pb-[20px] w-full text-center">
            <span className="capitalize font-semibold xxl:text-xxl xl:text-xl sm:text-lg text-base text-primary font-sora pb-[6px] block">
              # Trusted Partners
            </span>
            {/* <h2 className="xl:text-5xl md:text-4xl sm:text-3xl text-2.5xl max-md:text-[36px] font-semibold text-secondary font-sora leading-[1.2]">
              Our Clients
            </h2> */}
          </div>
          {/* Desktop View For Trusted Partners Static View */}
          <center className="min-md:px-[200px] mt-[0px] max-md:hidden">
              <img src="assets/clients/desktop-clients.png" alt="Trusted Partners" />
          </center>

          {/* Mobile View For Trusted Partners Slider View */}
          <center className="min-md:px-[200px] mt-[0px] md:hidden">
            <div className="swiper h3-partner_slider mt-11 overflow-hidden">
              <div className="swiper-wrapper">
                <div className="swiper-slide" data-aos="fade">
                  <img src="assets/clients/1.svg" alt="" />
                </div>
                <div
                  className="swiper-slide" data-aos="fade" data-aos-delay={100}
                >
                  <img src="assets/clients/2.svg" alt="" />
                </div>
                <div
                  className="swiper-slide" data-aos="fade" data-aos-delay={200}
                >
                  <img src="assets/clients/4.svg" alt="" />
                </div>
                <div
                  className="swiper-slide" data-aos="fade" data-aos-delay={300}
                >
                  <img src="assets/clients/5.svg" alt="" />
                </div>
                <div
                  className="swiper-slide" data-aos="fade" data-aos-delay={400}
                >
                  <img src="assets/clients/6.svg" alt="" />
                </div>
                <div
                  className="swiper-slide" data-aos="fade" data-aos-delay={500}
                >
                  <img src="assets/clients/7.svg" alt="" />
                </div>
                <div
                  className="swiper-slide" data-aos="fade" data-aos-delay={500}
                >
                  <img src="assets/clients/8.svg" alt="" />
                </div>
                <div
                  className="swiper-slide" data-aos="fade" data-aos-delay={500}
                >
                  <img src="assets/clients/9.png" alt="" className="h-[60px]" />
                </div>
                <div
                  className="swiper-slide" data-aos="fade" data-aos-delay={500}
                >
                  <img src="assets/clients/10.png" alt="" className="h-[60px]" />
                </div>
                <div
                  className="swiper-slide" data-aos="fade" data-aos-delay={500}
                >
                  <img src="assets/clients/11.png" alt="" className="h-[60px]" />
                </div>
                <div
                  className="swiper-slide" data-aos="fade" data-aos-delay={500}
                >
                  <img src="assets/clients/12.png" alt="" className="h-[60px]" />
                </div>
                <div
                  className="swiper-slide" data-aos="fade" data-aos-delay={500}
                >
                  <img src="assets/clients/13.svg" alt="" />
                </div>
                <div
                  className="swiper-slide" data-aos="fade" data-aos-delay={500}
                >
                  <img src="assets/clients/14.png" alt="" />
                </div>
                <div
                  className="swiper-slide" data-aos="fade" data-aos-delay={500}
                >
                  <img src="assets/clients/15.png" alt="" />
                </div>
                <div
                  className="swiper-slide" data-aos="fade" data-aos-delay={500}
                >
                  <img src="assets/clients/16.png" alt="" />
                </div>
              </div>
            </div>
          </center>
        </div>
      </section>
      {/* client section ends here */}

      {/* why choose us start here */}
      <section className="xxl:pb-[200px] lg:pb-[120px] md:pb-[80px] pb-[60px]">
        <div className="container">
          <div className="grid grid-cols-12 gap-[25px] items-center">
            <div className="lg:col-span-6 col-span-12">
              <div className="text-end relative before:absolute before:w-[71%] before:h-full before:bg-primary before:-left-[38px] before:z-[-1] before:rotate-[5deg] before:top-[13%] mt-[50px] lg:mr-[40px] max-lg:before:hidden">
                <figure className="overflow-hidden">
                  <img src="assets/img/choose-us.jpg" alt="img" className="w-full" />
                </figure>
                <div className="absolute xl:top-[-15%] xl:left-[-10%] lg:top-[-11%] lg:left-[-11%] top-[-12%] left-[-6%] xl:size-[200px] size-[170px] bg-white rounded-full flex items-center justify-center max-md:size-[165px]">
                  <img
                    alt="img"
                    src="assets/img/favicon.png"
                    className="size-[80px] p-[17px] bg-[#f5f5f5] rounded-full "
                  />
                  <img
                    alt="img"
                    src="assets/img/circle-image.png"
                    className="circle absolute size-auto bg-transparent p-[17px] w-[670px] mx-auto mt-[0px] text-center z-[1] animate-fa-spin"
                  />
                </div>
              </div>
            </div>
            <div className="lg:col-span-6 col-span-12">
              <div className="pb-[50px] w-[fit-content]">
                <span className="capitalize font-semibold xxl:text-xxl xl:text-xl sm:text-lg text-base text-primary font-sora pb-[6px] block">
                  # Why Choose Us
                </span>
                <h2 className="xl:text-5xl md:text-4xl sm:text-3xl text-2.5xl max-md:text-[36px] font-semibold text-secondary font-sora leading-[1.2]">
                  Easy, Everyday Health.
                </h2>
                <p className="text-base leading-[28px] text-gary font-normal border-l-[3px] border-primary pl-[27px] mt-[25px]">
                  We exist to make health simple, affordable, and centered around keeping you well, not just treating you when you're sick.
                </p>
              </div>
              <div className="sm:flex gap-[20px] mb-[25px] border-b border-[#D8D8D8] pb-[25px] group">
                <i
                  className="bg-[#1f87c9] size-[90px] flex items-center justify-center mb-25 relative 
							shadow-[#f05da866_0px_0px_24px_0px] rounded-full"
                >
                  <svg
                    className="size-[90px] p-[20px] group-hover:[transform:rotate3d(1,1,1,360deg)] duration-500"
                    width={45}
                    height={49}
                    viewBox="0 0 45 49"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M33.762 18.3703C33.762 18.0993 33.6541 17.8395 33.4621 17.6479C33.2701 17.4563 33.0097 17.3486 32.7381 17.3486H27.6191V12.2402C27.6191 11.9693 27.5112 11.7094 27.3192 11.5178C27.1272 11.3262 26.8668 11.2185 26.5953 11.2185H18.4048C18.1333 11.2185 17.8729 11.3262 17.6809 11.5178C17.4889 11.7094 17.381 11.9693 17.381 12.2402V17.3486H12.2619C11.9904 17.3486 11.73 17.4563 11.538 17.6479C11.346 17.8395 11.2381 18.0993 11.2381 18.3703V26.5437C11.2381 26.8147 11.346 27.0746 11.538 27.2662C11.73 27.4578 11.9904 27.5654 12.2619 27.5654H17.381V32.6738C17.381 32.9448 17.4889 33.2047 17.6809 33.3963C17.8729 33.5879 18.1333 33.6955 18.4048 33.6955H26.5953C26.8668 33.6955 27.1272 33.5879 27.3192 33.3963C27.5112 33.2047 27.6191 32.9448 27.6191 32.6738V27.5654H32.7381C33.0097 27.5654 33.2701 27.4578 33.4621 27.2662C33.6541 27.0746 33.762 26.8147 33.762 26.5437V18.3703Z"
                      stroke="white"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M1 7.69417V23.2993C1.06016 28.4557 2.70685 33.4691 5.71707 37.6605C8.72728 41.8519 12.9556 45.0189 17.8294 46.7326L20.1248 47.5785C21.6582 48.1405 23.3418 48.1405 24.8752 47.5785L27.1706 46.7326C32.0444 45.0189 36.2727 41.8519 39.2829 37.6605C42.2932 33.4691 43.9398 28.4557 44 23.2993V7.69417C43.9979 7.08107 43.8156 6.48205 43.4757 5.97136C43.1357 5.46067 42.6531 5.06076 42.0875 4.82121C35.8846 2.23873 29.2209 0.939488 22.5 1.00216C15.7791 0.939488 9.11545 2.23873 2.91248 4.82121C2.34694 5.06076 1.86428 5.46067 1.52432 5.97136C1.18436 6.48205 1.00206 7.08107 1 7.69417Z"
                      stroke="white"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </i>
                <div>
                  <h4 className="font-bold xl:text-2.3xl text-2xl pb-[7px] text-secondary leading-[1.2] font-sora">
                    Focus on Everyday Health
                  </h4>
                  <p className="text-base leading-[30px] text-gary fobt-normal">
                    Our OPD and Wellness Plans cover regular doctor visits and check-ups. We help you stay ahead of health issues.
                  </p>
                </div>
              </div>
              <div className="sm:flex gap-[20px] group">
                <i
                  className="bg-[#7ec067] size-[90px] flex items-center justify-center mb-[25px] relative 
							shadow-[#f05da866_0px_0px_24px_0px] rounded-full"
                >
                  <svg
                    className="size-[90px] p-[20px] group-hover:[transform:rotate3d(1,1,1,360deg)] duration-500"
                    width={49}
                    height={49}
                    viewBox="0 0 49 49"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M14.1661 36.9778C15.9035 36.3659 17.5836 35.6021 19.1869 34.6952M43.629 45.9939L42.7544 47.8331L32.2999 41.1938C31.3479 40.5881 30.6499 39.6555 30.3372 38.5713C30.0245 37.4871 30.1186 36.3261 30.6018 35.3064C31.0843 34.2865 31.9227 33.478 32.9595 33.0328C33.9962 32.5877 35.1598 32.5365 36.2316 32.889L48 36.7594L47.1254 38.5985M26.523 29.7911C31.9403 25.6919 40.8478 17.9388 40.8478 11.2811C40.8478 0.0745119 26.7846 -2.98257 22.4565 7.2043C18.1284 -2.98257 4.0652 0.0745119 4.0652 11.2811C4.0652 20.8467 21.7066 32.1841 22.4565 32.6745C24.8617 34.248 29.3185 36.1485 30.4731 35.6049M1 40.8477C1 42.7446 1.75353 44.5638 3.09483 45.9052C4.43612 47.2465 6.25531 48 8.15218 48C10.0491 48 11.8682 47.2465 13.2095 45.9052C14.5508 44.5638 15.3044 42.7446 15.3044 40.8477C15.3044 38.9508 14.5508 37.1316 13.2095 35.7903C11.8682 34.449 10.0491 33.6955 8.15218 33.6955C6.25531 33.6955 4.43612 34.449 3.09483 35.7903C1.75353 37.1316 1 38.9508 1 40.8477ZM6.10864 40.848C6.10864 41.39 6.32394 41.9097 6.70716 42.293C7.09039 42.6762 7.61016 42.8915 8.15212 42.8915C8.69409 42.8915 9.21385 42.6762 9.59708 42.293C9.98031 41.9097 10.1956 41.39 10.1956 40.848C10.1956 40.306 9.98031 39.7862 9.59708 39.403C9.21385 39.0198 8.69409 38.8045 8.15212 38.8045C7.61016 38.8045 7.09039 39.0198 6.70716 39.403C6.32394 39.7862 6.10864 40.306 6.10864 40.848Z"
                      stroke="white"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </i>
                <div>
                  <h4 className="font-bold xl:text-2.3xl text-2xl pb-[7px] text-secondary leading-[1.2] font-sora">
                    Clear, Affordable Value
                  </h4>
                  <p className="text-base leading-[30px] text-gary font-normal">
                    Get reliable access to quality care without the complexity of high deductibles or unexpected costs. It's smart budgeting for your health.
                  </p>
                </div>
              </div>
              <Link to="/plans" className="btn max-xxl:px-[30px] mt-[90px] max-md:mt-[30px]">
                <span>
                  Explore Our Plans
                  <i className="fa-solid fa-arrow-right" />
                </span>
              </Link>
            </div>
          </div>
        </div>
      </section>
      {/* why choose us ends here */}

      {/* testimonials start here */}
      <section className="lg:py-[120px] md:py-[80px] py-[60px] max-md:pt-[10px]">
        <div className="container">
          <div className="xl:pb-[50px] lg:pb-[40px] pb-[30px] w-[fit-content]">
            <span className="capitalize font-semibold xxl:text-xxl xl:text-xl sm:text-lg text-base text-primary font-sora pb-[6px] block">
              # Testimonial
            </span>
            <h2 className="xl:text-5xl md:text-4xl sm:text-3xl text-2.5xl max-md:text-[36px] font-semibold text-secondary font-sora leading-[1.2]">
              Words That Matter.
            </h2>
          </div>
          <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
            <div className="p-6 bg-white rounded-lg shadow-md transition-transform hover:shadow-lg hover:-translate-y-1">
              <div className="flex items-start mb-4">
                <div className="flex-shrink-0 mr-4">
                  <img className="w-12 h-12 rounded-full"
                    src="assets/img/t1.png"
                    alt="Profile image"
                  />
                </div>
                <div>
                  <h3 className="font-bold">Sarla Jain</h3>
                  <p className="text-sm text-gray-500">Gurugram</p>
                </div>
              </div>
              <p className="text-gray-700">
                "This plan gave me peace of mind. No more stress about doctor visits or surprise medical bills."
              </p>
            </div>
            <div className="p-6 bg-white rounded-lg shadow-md transition-transform hover:shadow-lg hover:-translate-y-1">
              <div className="flex items-start mb-4">
                <div className="flex-shrink-0 mr-4">
                  <img
                    className="w-12 h-12 rounded-full"
                    src="assets/img/t2.png"
                    alt="Profile image"
                  />
                </div>
                <div>
                  <h3 className="font-bold">Deshnath Gupta</h3>
                  <p className="text-sm text-gray-500">Mumbai</p>
                </div>
              </div>
              <p className="text-gray-700">
                "I’ve saved so much on consultations and tests. Truly worth every penny!"
              </p>
            </div>
            <div className="p-6 bg-white rounded-lg shadow-md transition-transform hover:shadow-lg hover:-translate-y-1">
              <div className="flex items-start mb-4">
                <div className="flex-shrink-0 mr-4">
                  <img
                    className="w-12 h-12 rounded-full"
                    src="assets/img/t3.png"
                    alt="Profile image"
                  />
                </div>
                <div>
                  <h3 className="font-bold">Ram Kumar</h3>
                  <p className="text-sm text-gray-500">Faridabad</p>
                </div>
              </div>
              <p className="text-gray-700">
                "Fast, hassle-free access to top doctors. Feels like having personal healthcare on call."
              </p>
            </div>
            <div className="p-6 bg-white rounded-lg shadow-md transition-transform hover:shadow-lg hover:-translate-y-1">
              <div className="flex items-start mb-4">
                <div className="flex-shrink-0 mr-4">
                  <img
                    className="w-12 h-12 rounded-full"
                    src="assets/img/t4.png"
                    alt="Profile image"
                  />
                </div>
                <div>
                  <h3 className="font-bold">Tejas Pandey</h3>
                  <p className="text-sm text-gray-500">Jaipur</p>
                </div>
              </div>
              <p className="text-gray-700">
                "My whole family is covered, from kids to parents. Support team is excellent!"
              </p>
            </div>
            <div className="p-6 bg-white rounded-lg shadow-md transition-transform hover:shadow-lg hover:-translate-y-1">
              <div className="flex items-start mb-4">
                <div className="flex-shrink-0 mr-4">
                  <img
                    className="w-12 h-12 rounded-full"
                    src="assets/img/t5.png"
                    alt="Profile image"
                  />
                </div>
                <div>
                  <h3 className="font-bold">Rajesh Sharma</h3>
                  <p className="text-sm text-gray-500">Delhi</p>
                </div>
              </div>
              <p className="text-gray-700">
                "Love the focus on prevention. Wellness check-ups and health tips keep me on track."
              </p>
            </div>
            <div className="p-6 bg-white rounded-lg shadow-md transition-transform hover:shadow-lg hover:-translate-y-1">
              <div className="flex items-start mb-4">
                <div className="flex-shrink-0 mr-4">
                  <img
                    className="w-12 h-12 rounded-full"
                    src="assets/img/t6.png"
                    alt="Profile image"
                  />
                </div>
                <div>
                  <h3 className="font-bold">Gurpreet</h3>
                  <p className="text-sm text-gray-500">Delhi</p>
                </div>
              </div>
              <p className="text-gray-700">
                "Professional, affordable, and reliable. I’ve recommended their plan to everyone I know."
              </p>
            </div>
          </div>

        </div>
      </section>
      {/* testimonials ends here */}

      {/* Association start here */}
      <section className="pb-[100px] max-md:pt-[10px]">
        <div className="container">
          <div className="pb-[30px] w-[fit-content]">
            <span className="capitalize font-semibold xxl:text-xxl xl:text-xl sm:text-lg text-base text-primary font-sora pb-[6px] block">
              # Collaboration
            </span>
            <h2 className="xl:text-5xl md:text-4xl sm:text-3xl text-2.5xl max-md:text-[36px] font-semibold text-secondary font-sora leading-[1.2]">
              Our Presence Across Key Locations in India
            </h2>
            <p className="mt-4">To deliver consistent and quality care, Cure Point OPD has partnered with reputed hospitals and clinics across our network. These collaborations allow our members to experience hassle-free OPD consultations, diagnostics, and wellness services backed by trusted medical institutions.</p>
          </div>

          <div className="flex gap-[400px] justify-center max-md:flex-wrap max-md:gap-[40px]">
            <img src="assets/map.svg" alt="Business Location Pointer " />
          </div>

          

        </div>
      </section>
      {/* Association ends here */}


    </main>
  );
};

export default HomePage;
